import {GeolocationIcon} from '@logistics-frontend/blocks'
import {CircularProgress, IconButton, useMediaQuery} from '@logistics-frontend/blocks/legacy'
import {theme} from '@logistics-frontend/blocks/lpc/theme'
import {Tooltip} from '@logistics-frontend/blocks/lpc/tooltip'
import clsx from 'clsx'
import React from 'react'

import {useClasses, useTooltipClasses} from './classes'

type Props = {
  error: string
  loading: boolean
  updateGeolocation: () => void
}

export const ResetGeolocation: React.FC<Props> = ({error, loading, updateGeolocation}) => {
  const classes = useClasses()
  const tooltipClasses = useTooltipClasses()
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'))

  return (
    <Tooltip classes={tooltipClasses} open={!!error && isDesktop} placement="left" title={error} arrow>
      <IconButton
        aria-label="геолокация"
        className={clsx(classes.button, classes.geolocationButton)}
        onClick={updateGeolocation}
      >
        {loading ? <CircularProgress color="primary" size={20} /> : <GeolocationIcon className={classes.icon} />}
      </IconButton>
    </Tooltip>
  )
}

export default ResetGeolocation
